<template>
  <div id="app">
    <loading-full v-if="isLoading"></loading-full>
    <component :is="layout"></component>
  </div>
</template>

<script>

  import LayoutBlank from "./layouts/blank/LayoutBlank";
  import LayoutFull from "./layouts/full/LayoutFull";
  import LoadingFull from "./components/loading-full/LoadingFull";
  import {mapGetters, mapActions} from 'vuex'

  const defaultLayout = 'LayoutBlank';

  export default {
    components: {
      LoadingFull,
      LayoutBlank,
      LayoutFull
    },
    data() {
      return {

      }
    },
    computed: {
      ...mapGetters([
        'isLoading'
      ]),
      layout() {
        return (this.$route.meta.layout || defaultLayout)
      }
    },
    methods: {
      ...mapActions({
        commonEndLoading: 'commonEndLoading'
      }),
    },
    mounted() {
      this.commonEndLoading();
    }

  }
</script>

<style lang="scss" scoped>

</style>
